import leadService from "@/services/leadService";
import haugazelService from "@/services/haugazelService";

const getDefaultState = () => {
  return {
    leadUuid: null,
    cameFrom: null,
    bxAllowed: false,
    completedSteps: [],
    localities: [],
    legalForms: [],
    elecProviders: [],
    gasProviders: [],
    leadDataForMail: {}
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setLeadUuid(state, value) {
      state.leadUuid = value;
    },
    setLeadDataForMail(state, value) {
      state.leadDataForMail = value;
    },
    setCameFrom(state, value) {
      state.cameFrom = value;
    },
    setBxAllowed(state, value) {
      state.bxAllowed = value;
    },
    pushCompletedSteps(state, value) {
      state.completedSteps.push(value);
    },
    setCompletedSteps(state, value) {
      state.completedSteps = value;
    },
    setLocalities(state, value) {
      state.localities = value;
    },
    setLegalForms(state, value) {
      state.legalForms = value;
    },
    setElecProviders(state, value) {
      state.elecProviders = value;
    },
    setGasProviders(state, value) {
      state.gasProviders = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async saveLeadDataForEmail(context, data) {
      let leadData = {
        uuid: data.uuid,
        lang: data.language,
        view: data.simulation == 1 ? 'simulation' : 'comparison',
        mail_date: data.mailDate,
        prospect_id: data.prospect_id
      };
      context.commit("setLeadDataForMail", leadData)
    },
    async getLegalForms(context) {
      try {
        let response = await haugazelService.getParameters();
        context.commit("setLegalForms", response.legalForms);
      } catch (error) {
        throw error;
      }
    },
    async saveLead(context, data) {
      try {
        if (!context.state.leadUuid) {
          let response = await leadService.new();
          context.commit("setLeadUuid", response.uuid);
        }

        data["uuid"] = context.state.leadUuid;
        await leadService.save(data);

        return context.state.leadUuid;
      } catch (error) {
        throw error;
      }
    },
    async saveProspect(context, data) {
      try {
        if (context.state.leadUuid) {
          return await leadService.saveProspect(data);
        }
      }
      catch (error) {
        throw error;
      }
    },
    async fillCompletedSteps(context) {
      let completedSteps = [];
      let sub = context.rootState.subscription;
      let contract = context.rootState.contract;
      let hasElec = context.rootGetters["contract/hasElec"];
      let hasGas = context.rootGetters["contract/hasGas"];
      let hasTou = context.rootGetters["contract/hasTou"];
      let hasElecMeterType = context.rootGetters["contract/hasElecMeterType"];

      if (
        sub.lastName &&
        sub.firstName &&
        sub.phone.number &&
        sub.mail &&
        (sub.customerType === 'pro' || sub.birthDate || (!sub.birthDate && sub.agentCustomId === 'AG000132')) &&
        contract.address.locality
      ) {
        completedSteps.push("PersonalDetails");

        if (contract.energies) {
          let context = false;

          switch(contract.energies) {
            case 'dual':
              context = contract.electricity.previousProvider !== null && contract.gas.previousProvider !== null
              break;
            case 'elec':
              context = contract.electricity.previousProvider !== null
              break;
            case 'gas':
              context = contract.gas.previousProvider !== null
              break;
            default: context = false;
          }

          if (context) {
            let consumption = false;

            if(hasElec) {
              if(hasTou) {
                consumption = !!(contract.electricity.consumption.high && contract.electricity.consumption.low)
              } else {
                consumption = !!contract.electricity.consumption.base
              }

              if(contract.electricity.product && contract.electricity.product.forced) consumption = true;
            }

            if(hasGas) {
              consumption = !!contract.gas.consumption

              if(contract.gas.product && contract.gas.product.forced) consumption = true;
            }

            // if move date not good
            if(contract.scenario === 'move') {
              consumption = consumption && ((hasElec && (contract.electricity.moveDate !== null || contract.electricity.openMeterDate !== null)) || (hasGas && (contract.gas.moveDate !== null || contract.gas.openMeterDate !== null)));
            }

            if ((!hasElec || hasElecMeterType) && consumption) {
              completedSteps.push("SituationContext");

              let offer = false;
              offer = (hasElec && contract.electricity.product !== null) || (hasGas && contract.gas.product !== null);

              if((contract.electricity.product && contract.electricity.product.forced) ||
                (contract.gas.product && contract.gas.product.forced))
                offer = true;

              if(offer) {
                completedSteps.push("Offer");

                let contractStep = false;

                if(contract.address.street && contract.address.number) {
                  if(contract.scenario === 'move') {
                    contractStep = ((hasElec && (contract.electricity.moveDate !== null || contract.electricity.openMeterDate !== null)) || (hasGas && (contract.gas.moveDate !== null || contract.gas.openMeterDate !== null)));
                  } else {
                    contractStep = true;
                  }
                }

                if(contractStep) {
                  completedSteps.push('Contract');

                  let payment = false;

                  if(sub.paymentMode === 'directDebit') {
                    payment = sub.holderFirstName && sub.holderLastName && sub.iban && sub.agreeDirectDebit && (sub.conditions || sub.statusScenario === '2step');
                  } else {
                    payment = sub.conditions || sub.statusScenario === '2step'
                  }

                  if(payment) {
                    completedSteps.push('Payment');

                    let confirmation = sub.signatureDate !== null || sub.isValid;

                    if(confirmation) {
                      completedSteps.push('Confirmation');
                    }
                  }
                }
              }
            }
          }
        }
      }

      await context.commit("setCompletedSteps", completedSteps);

      return true;
    }
  },
  getters: {
    isCompleted: state => route => {
      return state.completedSteps.indexOf(route) >= 0;
    },
    fromLead: state => {
      return state.cameFrom === "lead";
    },
    fromCustomer: state => {
      return state.cameFrom === "customer";
    },
    otherGasProviderId: () => {
      return "200076";
    },
    otherElecProviderId: () => {
      return "200076";
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/common.js